export const signeeReassignPickerTestIds = {
  searchInput: 'signee-reassign-search-input',
  option: 'signee-reassign-option',
};
